'use strict';

exports.init = function () {
	var validatorInstance = $('#unsubscribe-form').validate(),
		submitButton = $('button[type="submit"]');
	$('[name$="email"]').on('change', function () {
		if (validatorInstance.element(this)) {
			submitButton.prop('disabled', false);
		} else {
			submitButton.prop('disabled', true);
		}
	});
};
